import React from 'react';
import Button from '~ComponentsImproved/Button';
import { useI18n } from '~Hooks';
import usePaymentMethods from '~Hooks/Payments/usePaymentMethods';

interface PaymentMethodSelectorProps {
  onPaymentMethodSelected: (method: string) => void;
}

const PaymentMethodSelector = ({ onPaymentMethodSelected }: PaymentMethodSelectorProps) => {
  const paymentMethods = usePaymentMethods();
  const { i18n } = useI18n();

  return (
    <div style={{ width: '100%' }}>
      <h3>{i18n('GiftCard.SelectPaymentMethod')}</h3>
      {paymentMethods.all.map((method) => (
        <Button
          key={method.id}
          onTouchStart={() => onPaymentMethodSelected(method.id)}
          text={method.title}
          styleType="Confirm"
          style={{ marginBottom: '8px' }}
        />
      ))}
    </div>
  );
};

export default PaymentMethodSelector;
